import { render, staticRenderFns } from "./primaryBar.vue?vue&type=template&id=f603f6de"
import script from "./primaryBar.vue?vue&type=script&lang=js"
export * from "./primaryBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports